<template>
  <footer class="text-center bg-purple-800 text-white p-10 mb-10 mt-10">
        <p>Developement by <a class="text-indigo-200" href="https://hallofinsch.com/" target="_blank">Hallo Finsch</a> in <a href="https://react-covid-19-alert.firebaseapp.com/" target="_blank" class="text-purple-200">also in React Verion</a></p>
            
        </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>